import React from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import Constant from '../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import CustomFooter from '../../common/TableBottom'
import Toggle from 'react-toggle'
import ActivitiesController from '../../common/activitiesController/ActivitiesController'

class AdsList extends React.Component {
  state = {
    adsData: [],
    isSaving: false,
    limit: 10,
    pageNumber: 0,
    disabled: false,
    keyword: '',
  }

  componentDidMount() {
    this.adsList()
  }

  adsList = async () => {
    this.setState({
      isSaving: true,
    })

    await axios
      .get(Constant.getAPI() + `/ads/list-ads`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          limit: this.state.limit,
          pageNumber: this.state.pageNumber,
          keyword: this.state.keyword,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            adsData: res.data.data,
            // disabled: res.data?.pagination?.next ? false : true,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isSaving: false,
        })
      })
  }

  deleteAd = (id) => {
    Swal.fire({
      title: 'Are you sure to delete this Ad?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        var token = `Bearer ${localStorage.getItem('loged_In_auth')}`

        axios
          .delete(Constant.getAPI() + `/ads/delete-ad/${id}`, {
            headers: {
              Authorization: token,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
          })
          .then(() => {
            Swal.fire({
              toast: true,
              icon: 'success',
              position: 'top-end',
              title: 'Deleted Successfully!',
              showConfirmButton: false,
              timerProgressBar: true,
              timer: 2500,
            })
            this.adsList()
          })
          .catch((err) => {
            if (err?.response?.status === 401) {
              Constant.getAuthLogout()
            } else {
              Swal.fire({
                title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                icon: 'error',
                text: '',
                type: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
              })
            }
          })
      }
    })
  }

  onSearch = (event) => {
    this.setState(
      {
        keyword: event.target.value,
        pageNumber: 0,
      },
      () => {
        if (this.debounceTimeout) clearTimeout(this.debounceTimeout)

        this.debounceTimeout = setTimeout(() => {
          this.adsList()
        }, 500)
      }
    )
  }

  clearSearch = () => {
    this.setState(
      {
        keyword: '',
        pageNumber: 0,
      },
      () => {
        this.adsList()
      }
    )
  }

  handleStatusChange = async (id, status) => {
    let data = { id, is_active: status }
    let that = this
    await axios
      .post(Constant.getAPI() + '/ads/update-ad', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire({
            toast: true,
            icon: 'success',
            position: 'top-end',
            title: `Status has been Changed`,
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 2500,
          })
          that.adsList()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    const customSearchRender = (searchText, handleSearch, hideSearch) => {
      return (
        <div className="container">
          <div className="d-flex justify-content-around">
            <i className="f-16 icofont icofont-search m-t-10 m-r-10"></i>
            <input
              type="search"
              className="form-control custom-input-search"
              placeholder="Search"
              value={this.state.keyword}
              name="keyword"
              onChange={this.onSearch}
            />
            <span
              className="pointer m-t-5"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                this.clearSearch(hideSearch)
              }}
            >
              <i className="f-24 icofont icofont-close m-l-10"></i>
            </span>
          </div>
        </div>
      )
    }

    const columns = [
      {
        name: 'image_en',
        label: 'Image',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (image_path) => {
            return (
              <div>
                <img
                  src={
                    image_path !== undefined && image_path !== null && image_path !== {}
                      ? Constant.getImage() + image_path
                      : './assets/images/icon.png'
                  }
                  className="img-fluid img-40"
                  alt="tbl"
                />
              </div>
            )
          },
        },
      },
      {
        name: 'title_en',
        label: 'Ad Name : English',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value || '--'
          },
        },
      },
      {
        name: 'title_ar',
        label: 'Ad Name: Arabic',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value || '--'
          },
        },
      },
      {
        name: 'order',
        label: 'Order',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value) => {
            return value || '--'
          },
        },
      },
      // {
      //     name: "states",
      //     label: "Governorate",
      //     options: {
      //         filter: true,
      //         sort: true,
      //         customBodyRender: (state, tableMeta) => {
      //             return (
      //                 <div>
      //                     {state !== undefined && state !== null && state !== {}
      //                         ? state.name_en
      //                         : ""}
      //                 </div>
      //             );
      //         },
      //     },
      // },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (isActive, tableMeta) => {
            const id = tableMeta.rowData[tableMeta.rowData.length - 1]
            return (
              <div>
                <Toggle
                  id={id}
                  checked={isActive}
                  value={isActive + ''}
                  onChange={this.handleStatusChange.bind(this, id, !isActive)}
                />
              </div>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div>
                <Link
                  to={`/ads/add/${id}`}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                <span
                  onClick={this.deleteAd.bind(this, id)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Delete"
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                </span>
                <ActivitiesController refId={id}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      viewColumns: false,
      print: false,
      download: false,
      filter: false,
      search: false,
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            count={this.state.limit}
            pageNumber={this.state.pageNumber}
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState(
          {
            pageNumber: currentPage,
          },
          () => {
            this.adsList()
          }
        )
      },
      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          {
            limit: numberOfRows,
          },
          () => {
            this.adsList()
          }
        )
      },
      customSearchRender: customSearchRender,
      onSearchClose: () => {
        this.clearSearch()
      },
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Ad Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Ad's List</h4>
                    </div>
                  </div>
                  <Link
                    to="/ads/add"
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                    data-modal="modal-13"
                  >
                    {' '}
                    <i className="icofont icofont-plus m-r-5"></i> Add
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Ads List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          className="table-responsive"
                          data={this.state.adsData}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AdsList
